<template>
    <section class="choose-model" v-show="visible">
        <div class="choose-top">
            <el-row :gutter="15">
                <el-col :span="20" class="text">{{title}}({{count}})</el-col>
                <el-col :span="4">  
                    <template v-if="i18nText.clear">
                          <el-button size="mini" @click="clear">{{$t(i18nText.clear)}}</el-button>
                    </template>
                    <template v-else>
                         <el-button size="mini" @click="clear">清空</el-button>
                    </template>
                </el-col>
            </el-row>
        </div>
        <div class="choose-middle">
            <template v-if="!isShowImg">
                <ul class="no-imgul">
                    <li v-for="(item,index) in list">
                        <span class="fold-title">
                            <template v-if="item.list && item.list.length > 0">
                                <i class="el-icon-arrow-up expand" v-if="item.expand" @click="expand(item)"></i>
                                <i class="el-icon-arrow-down expand" v-if="!item.expand" @click="expand(item)"></i>
                            </template>    
                            <span v-html="item.text">{{item.text}}</span></span>
                        <i class="el-icon-close" @click="deleteItem(index)"></i>
                        <el-collapse-transition>
                            <ul class="unfold-list" v-if="item.list && item.list.length > 0" v-show="item.expand">
                                <li v-for="(subItem,index) in item.list">
                                    <span>{{subItem.text}}</span>
                                    <i class="el-icon-close" @click="deleteSubItem(item,index)"></i>
                                </li>
                            </ul>
                        </el-collapse-transition>
                    </li>
                </ul>
            </template>
            <template v-else>
                <el-row class="imgul" :gutter="15">
                    <el-col :span="8" v-for="(item,index) in list" class="imgul-item">
                        <div class="imgbox">
                            <img :src="item.url" :alt="item.text">
                            <span></span>
                        </div>
                        <span class="text" :title="item.text" v-html="item.text">{{item.text}}</span>
                        <i class="el-icon-close" @click="deleteItem(index)"></i>
                    </el-col>
                </el-row>
            </template>    
        </div>
        <div class="choose-bottom">
            <slot name="operate">
                <el-row :gutter="15">
                    <el-col :span="20">
                        <el-input v-model="queryValue" size="small"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <template v-if="i18nText.search">
                            <el-button size="small" type="primary" @click.native="search">{{$t(i18nText.search)}}</el-button>
                        </template>
                        <template v-else>
                            <el-button size="small" type="primary" @click.native="search">检索</el-button>
                        </template>
                    </el-col>
                </el-row>
            </slot>
        </div>
    </section>
</template>

<script>
export default {
    name:'ipChooseModel',
    props:{
        visible:{type:Boolean,default:false},
        title:{type:String,default:''},
        isShowImg:{type:Boolean,default:false},
        list:{type:Array,default(){return []}},
        count:{type:Number,default:0},
        i18nText:{type:Object,default(){return {}}}
    },
    data(){
        return{
            queryValue:''
        }
    },
    methods:{
        clear(){
            this.$emit('clear')
        },
        deleteItem(index){
            this.$emit('delete-item',index)
        },
        deleteSubItem(item,index){
            this.$emit('delete-sub-item',item,index)
        },
        search(){
            this.$emit('search',this.queryValue)
        },
        expand(item){
            item.expand = !item.expand ;
        }
    }
}
</script>

<style lang="scss" scoped>
.choose-model{
    position: fixed;
    z-index: 999;
    right: 77px;
    bottom: 20%;
    width: 400px;
    height: 400px;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    .choose-top{
        box-sizing: border-box;
        width: 100%;
        height: 36px;
        padding: 4px 15px;
        background: #e8f0f8;
        .text{
            line-height: 28px;
            font-size: $sm-font-size;
        }
    }
    .choose-middle{
        height: 318px;
        overflow-y: auto;
        .no-imgul{
            padding: 8px 0;
            li{
                font-size: $sm-font-size;
                padding: 0 0 0 15px;
                line-height: 28px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                position: relative;
                .fold-title{
                    display: inline-block;
                    width: 88%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .el-icon-close{
                    position: absolute;
                    right: 10px;
                    top: 0;
                    font-size: 16px;
                    line-height: 28px;
                    color: $theme-color;
                    cursor: pointer;
                }
                .expand{
                    margin-right: 5px;
                    cursor: pointer;
                }
                .unfold-list{
                    li{
                        padding: 0 30px 0 18px;
                    }
                }
            }
        }
        .imgul{
            text-align: center;
            font-size: $sm-font-size;
            margin: 0!important;
            padding: 8px 10px 8px 0;
            .imgul-item{
                position: relative;
                padding-right: 20px!important;
                box-sizing: border-box;
                margin-bottom: 10px;
                .imgbox{
                    width: 100%;
                    height: 100px;
                    img{
                        max-width: 100%;
                        max-height: 100%;
                        vertical-align: middle;
                    }
                    span{
                         display:inline-block;  
                         height:100%;
                         vertical-align:middle;
                    }
                    border: 1px solid #d9d9d9;
                    margin-bottom: 8px;
                }
                .text{
                    display: inline-block;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                i{
                    position: absolute;
                    right: 0;
                    top: 0;
                    font-size: 16px;
                    cursor: pointer;
                    color: $theme-color;
                }
            }
        }
    }
    .choose-bottom{
        box-sizing: border-box;
        padding: 7px 15px;
        height: 46px;
        border-top: 1px solid #d9d9d9;
    }
    border: 1px solid #d9d9d9;
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
}
</style>

